/**
 * 系统布局配置
 * 对应 PHP/EB: view/mer/src/store/modules/settings.js
 */
import defaultSettings from '@/settings';
import { defineStore } from 'pinia';

const { showSettings, tagsView, fixedHeader, sidebarLogo } = defaultSettings;

/** 对应 EB: JSON.parse(localStorage.getItem('themeColor')) || '#437FFD' */
function loadThemeColor(): string {
    try {
        const raw = localStorage.getItem('themeColor');
        if (raw) {
            const parsed = JSON.parse(raw);
            if (typeof parsed === 'string' && parsed) {
                return parsed;
            }
        }
    } catch {
        // ignore invalid storage
    }
    return '#437FFD';
}

const useSettingsStore = defineStore('settings', {
    state: () => ({
        theme: loadThemeColor(),
        showSettings: showSettings,
        tagsView: tagsView,
        fixedHeader: fixedHeader,
        sidebarLogo: sidebarLogo,
        /** 编辑页未保存（对应 EB settings.isEdit，离开路由时提示） */
        isEdit: false,
    }),
    actions: {
        /** 对应 EB: settings/changeSetting */
        changeSetting(data: { key: string; value: unknown }) {
            const { key, value } = data;
            if (Object.prototype.hasOwnProperty.call(this, key)) {
                Reflect.set(this, key, value);
            }
        },
        /** 对应 EB: settings/setEdit */
        setEdit(isEdit: boolean) {
            this.isEdit = isEdit;
        },
    },
});

export default useSettingsStore;
